import { print } from "graphql";
import {
  CompanionLlmStreamDocument,
  CompanionLlmStreamSubscription,
  CompanionLlmStreamSubscriptionVariables,
} from "@axio/graphql/generated/graphql";
import { createGraphqlSseClient } from "./graphqlSseClient";

type CompanionLlmStreamEvent = NonNullable<CompanionLlmStreamSubscription["companionLlmStream"]>;

type StreamHandlers = {
  onChunk?: (event: CompanionLlmStreamEvent) => void;
  onComplete?: () => void;
  onError?: (error: Error) => void;
};

const COMPANION_LLM_STREAM_SUBSCRIPTION = print(CompanionLlmStreamDocument);

const { startStream, cancelStream } = createGraphqlSseClient<
  CompanionLlmStreamEvent,
  CompanionLlmStreamSubscriptionVariables
>({
  operationName: "CompanionLlmStream",
  query: COMPANION_LLM_STREAM_SUBSCRIPTION,
  getPayload: (parsed) => parsed?.data?.companionLlmStream as CompanionLlmStreamEvent | undefined,
  logPrefix: "companionGraphqlSseClient",
});

export const cancelCompanionLlmStream = () => {
  cancelStream();
};

export const startCompanionLlmStream = async (
  question: string,
  controller: AbortController,
  handlers: StreamHandlers = {},
  options?: Omit<CompanionLlmStreamSubscriptionVariables, "question">
) => {
  await startStream({ question, ...options }, controller, handlers);
};
